export default "__VITE_ASSET__4b9e6360__"